import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { fn } from '@app/utils';

const CountdownTimer = () => {
    const expiry = fn.getImpersonationTokenExpiry() ?? 0;
    const [timeLeft, setTimeLeft] = useState(() => expiry - Date.now());

    useEffect(() => {
        const interval = setInterval(() => {
            if (expiry) {
                setTimeLeft(expiry - Date.now());
            }
        }, 1000);
        return () => clearInterval(interval);
    });

    const classes = classNames('countdown-timer text-bold', {
        'text-red': timeLeft <= 60000,
    });

    return <div className={classes}>{fn.formatTimeToDoubleDigits(timeLeft)}</div>;
};

export default CountdownTimer;
